module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesRomantic@2x.0ff6f32.jpg";